// ------------------------------------------------------------
// hide/show favWrapper

export default function HideShowFavWrapper(favWrapper, count) {
  favWrapper.classList[count >= 1 ? "remove" : "add"]("d-none");
}
